import { MyError } from '~/common/types'

export class AuthError extends MyError {}
